import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_EVENT_EVENTLIST_TITLE ({ commit }) {
      const query = `query events (
        $order: [CrmEventSortInput!]
        $where: CrmEventFilterInput
      ) {
        response: events (order: $order, where: $where) {
          field_001
          eventlisttitleDE
          eventlisttitleEN
          onlinestatusJoin
        }
      }`

      const variables = {
        where: {
          onlinestatusJoin: { neq: '2' }
        }
      }

      const { data } = await gql({ query, variables })
      if (!data.errors) {
        const eventArray = []
        for (const event of data.data.response) {
          const eventlisttitle = (event.eventlisttitleEN !== null && event.eventlisttitleEN !== '' && event.eventlisttitleEN !== '&nbsp;') ? event.eventlisttitleEN : event.eventlisttitleDE
          if (eventlisttitle !== null && eventlisttitle !== '' && eventlisttitle !== '&nbsp;') {
            if (!eventArray.includes(eventlisttitle)) {
              eventArray.push(eventlisttitle)
            }
          }
        }
        commit('SET_EVENT_TITLES', eventArray)
      }

      return data
    },

    async GET_EVENTPOOL_THEMES ({ commit }) {
      const query = `query eventpools (
        $order: [EventpoolSortInput!]
        $where: EventpoolFilterInput
      ) {
        response: eventpools (order: $order, where: $where) {
          field_001
          thema_en
        }
      }`

      const variables = {
        order: {
          thema_en: 'ASC'
        }
      }

      const { data } = await gql({ query, variables })
      if (!data.errors) {
        const eventpoolArray = []
        for (const eventpool of data.data.response) {
          if (!eventpoolArray.includes(eventpool.thema_en)) {
            if (eventpool.thema_en !== null && eventpool.thema_en !== '' && eventpool.thema_en !== '&nbsp;') {
              eventpoolArray.push(eventpool.thema_en)
            }
          }
        }
        commit('SET_EVENTPOOL_THEMES', eventpoolArray)
      }

      return data
    },

    async GET_INTERESTS_STATUS ({ commit }) {
      const query = `query gRUNDWERTEInteresseStatuses (
        $order: [GRUNDWERTEInteresseStatusSortInput!]
        $where: GRUNDWERTEInteresseStatusFilterInput
      ) { 
       response: gRUNDWERTEInteresseStatuses (where: $where order: $order) {
         field_001
         status
         sortierung
        }
      }`

      const variables = {
        order: {
          sortierung: 'ASC'
        }
      }

      const { data } = await gql({ query, variables })

      if (!data.errors) {
        commit('SET_INTERESTS_STATUS', data.data.response)
      }

      return data
    }
}
